import React from 'react';
import { RangeDatepicker, SingleDatepicker, DatepickerConfigs } from 'chakra-dayzed-datepicker';

// Türkçe ayarlar
const turkishConfig: DatepickerConfigs = {
  dateFormat: 'dd.MM.yyyy',
  monthNames: [
    'Ocak',
    'Şubat',
    'Mart',
    'Nisan',
    'Mayıs',
    'Haziran',
    'Temmuz',
    'Ağustos',
    'Eylül',
    'Ekim',
    'Kasım',
    'Aralık',
  ],
  dayNames: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
  firstDayOfWeek: 1, // Pazartesi
};

interface TurkishRangeDatepickerProps {
  selectedDates: Date[];
  onDateChange: (dates: Date[]) => void;
  minDate?: Date;
  maxDate?: Date;
  disabled?: boolean;
  usePortal?: boolean;
  id?: string;
  name?: string;
}

export const TurkishRangeDatepicker: React.FC<TurkishRangeDatepickerProps> = ({
  selectedDates,
  onDateChange,
  minDate,
  maxDate,
  disabled = false,
  usePortal = false,
  id,
  name,
}) => {
  return (
    <RangeDatepicker
      configs={turkishConfig}
      selectedDates={selectedDates}
      onDateChange={onDateChange}
      minDate={minDate}
      maxDate={maxDate}
      disabled={disabled}
      usePortal={usePortal}
      id={id}
      name={name}
    />
  );
};

interface TurkishSingleDatepickerProps {
  date?: Date;
  onDateChange: (date: Date) => void;
  minDate?: Date;
  maxDate?: Date;
  disabled?: boolean;
  usePortal?: boolean;
  id?: string;
  name?: string;
}

export const TurkishSingleDatepicker: React.FC<TurkishSingleDatepickerProps> = ({
  date,
  onDateChange,
  minDate,
  maxDate,
  disabled = false,
  usePortal = false,
  id,
  name,
}) => {
  return (
    <SingleDatepicker
      configs={turkishConfig}
      date={date}
      onDateChange={onDateChange}
      minDate={minDate}
      maxDate={maxDate}
      disabled={disabled}
      usePortal={usePortal}
      id={id}
      name={name}
    />
  );
};
